<script lang="ts" setup></script>

<template>
  <div :class="$style.container">
    <div :class="[$style.container__image, $style.image]">
      <slot name="image" />
    </div>
    <div :class="[$style.container__stepNum, $style.stepNum]">
      <slot name="stepNum" />
    </div>
    <p :class="[$style.container__tittle, $style.title]">
      <slot name="title" />
    </p>
    <p :class="[$style.container__description, $style.description]">
      <slot name="description" />
    </p>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background-color: $color-surface-primary;
}

.image {
  line-height: 0;
}

.stepNum {
  margin-top: 24px;
  line-height: 0;
}

.title {
  margin-top: 12px;
  font-size: 20px;
  font-weight: bold;
  line-height: 36px;
}

.description {
  text-align: start;
  margin-top: 12px;
  font-size: 16px;
  font-weight: normal;
  line-height: 28.8px;
}
</style>
